import { render, staticRenderFns } from "./format-with-manage.vue?vue&type=template&id=19ce5d2a"
import script from "./format-with-manage.vue?vue&type=script&lang=js"
export * from "./format-with-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports